/* Variant Select Availability v3 - Hides unavailable option values
   Only filters DOWNSTREAM options based on UPSTREAM selections.
   e.g. Design (option1) always shows all. Color (option2) filters by Design.
   Size (option3) filters by Design + Color. */
(function(){
  'use strict';

  function init(){
    var jsonEl = document.querySelector('[data-product-json]');
    if(!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch(e){ return; }
    var product = data.product || data;
    if(!product || !product.variants) return;

    var variants = product.variants;

    function getAllSelectors(){
      var items = [];
      document.querySelectorAll('.product-form__option').forEach(function(wrap){
        var type = wrap.getAttribute('data-selector-type');
        var sel = wrap.querySelector('select.product-form__single-selector');
        var radios = wrap.querySelectorAll('input[type="radio"].product-form__single-selector, input[type="radio"].color-swatch__radio, input[type="radio"].variant-swatch__radio, input[type="radio"].block-swatch__radio');
        if(sel){
          var pos = parseInt(sel.getAttribute('data-option-position'),10);
          items.push({type:'select', el:sel, pos:pos, wrap:wrap});
        } else if(radios.length){
          var pos2 = parseInt(radios[0].getAttribute('data-option-position'),10);
          items.push({type:'radio', radios:radios, pos:pos2, wrap:wrap, selectorType:type});
        }
      });
      // Sort by position so we process in order
      items.sort(function(a,b){ return a.pos - b.pos; });
      return items;
    }

    function getSelected(selectors){
      var vals = {};
      selectors.forEach(function(s){
        if(s.type === 'select'){
          vals[s.pos] = s.el.value;
        } else {
          s.radios.forEach(function(r){
            if(r.checked) vals[s.pos] = r.value;
          });
        }
      });
      return vals;
    }

    function update(){
      var selectors = getAllSelectors();
      var selected = getSelected(selectors);

      selectors.forEach(function(s, idx){
        // First option (position 1 / index 0) — never filter, always show all
        if(idx === 0) return;

        var pos = s.pos;
        var optKey = 'option' + pos;

        // Only consider UPSTREAM options (lower position) for filtering
        var upstreamPositions = [];
        for(var i = 0; i < idx; i++){
          upstreamPositions.push(selectors[i].pos);
        }

        if(s.type === 'select'){
          Array.from(s.el.options).forEach(function(opt){
            var val = opt.value;
            var exists = variants.some(function(v){
              if(v[optKey] !== val) return false;
              for(var u = 0; u < upstreamPositions.length; u++){
                var up = upstreamPositions[u];
                if(v['option'+up] !== selected[up]) return false;
              }
              return true;
            });
            opt.style.display = exists ? '' : 'none';
            opt.disabled = !exists;
          });
          var curOpt = s.el.querySelector('option[value="'+CSS.escape(s.el.value)+'"]');
          if(curOpt && curOpt.disabled){
            var first = s.el.querySelector('option:not([disabled])');
            if(first){
              s.el.value = first.value;
              s.el.dispatchEvent(new Event('change',{bubbles:true}));
            }
          }
        } else {
          var needReselect = false;
          var firstAvail = null;
          s.radios.forEach(function(radio){
            var val = radio.value;
            var exists = variants.some(function(v){
              if(v[optKey] !== val) return false;
              for(var u = 0; u < upstreamPositions.length; u++){
                var up = upstreamPositions[u];
                if(v['option'+up] !== selected[up]) return false;
              }
              return true;
            });
            var swatchEl = radio.closest('.color-swatch, .variant-swatch, .block-swatch');
            if(swatchEl){
              swatchEl.style.display = exists ? '' : 'none';
            }
            if(!exists && radio.checked) needReselect = true;
            if(exists && !firstAvail) firstAvail = radio;
          });
          if(needReselect && firstAvail){
            firstAvail.checked = true;
            firstAvail.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
      });
    }

    document.querySelectorAll('.product-form__single-selector, .color-swatch__radio, .variant-swatch__radio, .block-swatch__radio').forEach(function(el){
      el.addEventListener('change', function(){ setTimeout(update, 50); });
    });

    setTimeout(update, 200);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
